module.exports = __webpack_public_path__ + "static/media/Magmar_gaussian2.2074185f.png";